// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"605":"48494c31","2432":"f92721c4"}[chunkId] + ".chunk.css";
};